document.addEventListener('DOMContentLoaded', () => {
    const menuBtn = document.querySelector('.menu-btn');
    const mobileMenu = document.querySelector('.mobile-menu');
    const closeBtn = document.querySelector('.mobile-menu > .close');

    menuBtn.addEventListener('click', () => {
        mobileMenu.classList.add('shown');
    });

    closeBtn.addEventListener('click', () => {
        mobileMenu.classList.remove('shown');
    });


    document.querySelectorAll('a[href="#booking"]').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            document.querySelector('.section-contacts-popup')?.classList.add('visible');
        });
    });

    const popupSection = document.querySelector('.section-contacts-popup');
    popupSection?.addEventListener('click', function (e) {
        if (e.target === this || e.target.closest('.close')) {
            e.preventDefault();
            this.classList.remove('visible');
        }
    });


    document.querySelectorAll('[data-video-player]').forEach((player) => {
        const video = player.querySelector('video');
        const playButton = player.querySelector('[data-video-play]');

        playButton.addEventListener('click', () => {
            // Stop all other videos
            document.querySelectorAll('[data-video-player]').forEach((otherPlayer) => {
            if (otherPlayer !== player) {
                const otherVideo = otherPlayer.querySelector('video');

                otherVideo.pause();
            }
            });

            // Play the clicked video
            video.play();
            playButton.style.display = 'none';
        });

        video.addEventListener('pause', () => {
            // Keep video frame and poster hidden
        });

        video.addEventListener('play', () => {
            playButton.style.display = 'none';
        });

        video.addEventListener('ended', () => {
            playButton.style.display = 'flex';
        });
    });

    var elem = document.querySelector('.finished-grid');

    if (elem && window.innerWidth >= 601) {
        setTimeout(() => {
            new Masonry(elem, {
                itemSelector: '.grid-item',
                gutter: 22
            });
        }, 1000);
    }


    var swiper = new Swiper('.swiper.plants', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          601: {
            slidesPerView: 2,
          },
          901: {
            slidesPerView: 3,
          },
        },
    });

    document.querySelector('.plants-arrow-left')?.addEventListener('click', () => {
        document.querySelector('.swiper.plants .swiper-button-prev')?.click();
    });
    document.querySelector('.plants-arrow-right')?.addEventListener('click', () => {
        document.querySelector('.swiper.plants .swiper-button-next')?.click();
    });

    var swiper = new Swiper('.swiper.reception-hall', {
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
        },
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
    });

    var swiper = new Swiper('.swiper.space', {
        slidesPerView: 4,
        grid: {
          rows: 2,
          fill: "row",
        },
        spaceBetween: 22,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    document.querySelector('.space-prev')?.addEventListener('click', () => {
        document.querySelector('.swiper.space .swiper-button-prev')?.click();
    });

    document.querySelector('.space-next')?.addEventListener('click', () => {
        document.querySelector('.swiper.space .swiper-button-next')?.click();
    });


    /* CALENDAR ------------------------------------------------------------------------------- */

    const calGrid = document.querySelector('#calGrid');
    const calMonth = document.getElementById("calMonth");

    if (!calGrid) return;

    const calendar = calGrid.closest('.calendar');
    const dates = calendar.getAttribute('data-dates');
    if (!dates) return;

    const strippedDates = dates.replace(/<\/?p[^>]*>/gi, '');

    const now = new Date();
    const currentMonth = now.getMonth() + 1; // JS months are 0-based
    const currentYear = now.getFullYear();

    const availableDates = strippedDates
        .split(',')
        .map(date => date.trim())
        .filter(Boolean)
        .map(date => {
            const [day, month, year] = date.split('.').map(Number);

            return { day, month, year };
        })
        .filter(({ month, year }) =>
            month === currentMonth && year === currentYear
        )
        .map(({ day, month, year }) =>
            `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
        );

    console.log(currentMonth);
    console.log(availableDates);


    function renderCalendar(dates) {
        if (!dates.length) return;

        // Get year/month directly from the date string
        const [year, monthNumber] = dates[0].split("-").map(Number);
        const month = monthNumber - 1;

        console.log("year:", year);
        console.log("month:", month);

        calMonth.textContent = new Intl.DateTimeFormat("en-US", {
            month: "long",
            year: "numeric"
        }).format(new Date(year, month, 1));

        const weekdays = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

        calGrid.innerHTML = "";

        weekdays.forEach(day => {
            calGrid.insertAdjacentHTML(
                "beforeend",
                `<div class="dow">${day}</div>`
            );
        });

        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);

        const daysInMonth = lastDay.getDate();

        // Monday = 0, Sunday = 6
        const firstWeekday = (firstDay.getDay() + 6) % 7;

        const prevMonthLastDay = new Date(year, month, 0).getDate();

        for (let i = firstWeekday; i > 0; i--) {
            calGrid.insertAdjacentHTML(
                "beforeend",
                `<div class="cal-cell muted">${prevMonthLastDay - i + 1}</div>`
            );
        }

        const availableSet = new Set(dates);

        for (let day = 1; day <= daysInMonth; day++) {

            const dateString =
                `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

            const open = availableSet.has(dateString);

            calGrid.insertAdjacentHTML(
                "beforeend",
                `<div class="cal-cell ${open ? "open" : ""}">
                    ${day}
                </div>`
            );
        }

        const totalCells = firstWeekday + daysInMonth;
        const remaining = (7 - (totalCells % 7)) % 7;

        for (let day = 1; day <= remaining; day++) {
            calGrid.insertAdjacentHTML(
                "beforeend",
                `<div class="cal-cell muted">${day}</div>`
            );
        }
    }

    renderCalendar(availableDates);
});

window.addEventListener('load', initMasonry);